import { deepClone } from '../util/deepClone';

import labelTemplates from './defaultLabelTemplates';
import rowTemplateThresholds from './defaultRowTemplateThresholds';

// Customize label templates for locale
const customLabelTemplates = deepClone(labelTemplates);
customLabelTemplates.xAxis.doubleRow.weeks.default = '%-d/%-m';

export default {
	decimal: '.',
	thousands: ',',
	grouping: [3],
	currency: ['$', ''],
	dateTime: '%a %b %e %X %Y', // %c
	time: '%-I:%M%p', // 12-hour format
	periods: ['am', 'pm'], // %p
	date: '%-d/%-m/%Y', // %x
	days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'], // %A
	shortDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'], // %a
	months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'], // %B
	shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'], // %b
	translations: {},
	labelTemplates: customLabelTemplates,
	rowTemplateThresholds
};
